import React from "react";
import { Col, Row } from "react-bootstrap";

const PersonalAssets = ({ data }) => {
  return (
    <div>
      <section className="view-data">
        <Row className="main-view-email pt-3">
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Cash on Hand:</strong>
              {data?.cash_on_hand || "--"}
            </div>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Personal Bank Account</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Full Name:</strong>
              {data?.personal_bank_account?.fullname || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Bank Address:</strong>
              {data?.personal_bank_account?.address_of_bank || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Account Type:</strong>
              {data?.personal_bank_account?.account_type || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Account Number:</strong>
              {data?.personal_bank_account?.account_number || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Account Balance:</strong>
              {data?.personal_bank_account?.account_balance || "--"}
            </div>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Additional Bank Account</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Full Name:</strong>
              {data?.additional_bank_account?.fullname || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Bank Address:</strong>
              {data?.additional_bank_account?.address_of_bank || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Account Type:</strong>
              {data?.additional_bank_account?.account_type || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Account Number:</strong>
              {data?.additional_bank_account?.account_number || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Account Balance:</strong>
              {data?.additional_bank_account?.account_balance || "--"}
            </div>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Investment</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Investment Type:</strong>
              {data?.investment?.type || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Full Name:</strong>
              {data?.investment?.fullname || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Address of Institution:</strong>
              {data?.investment?.address_of_institution || "--"}
            </div>
          </Col>

          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Account Number:</strong>
              {data?.investment?.account_number || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Account Balance:</strong>
              {data?.investment?.account_balance || "--"}
            </div>
          </Col>
          <Col md={12} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Whole Life Insurance:</strong>
              {data?.whole_life_insurance || "--"}
            </div>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Credit Account</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Full Name:</strong>
              {data?.credit_accounts?.fullname || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Bank Address:</strong>
              {data?.credit_accounts?.address_of_bank || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Account Type:</strong>
              {data?.credit_accounts?.account_type || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Account Number:</strong>
              {data?.credit_accounts?.account_number || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Account Balance:</strong>
              {data?.credit_accounts?.account_balance || "--"}
            </div>
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default PersonalAssets;
